<template>
  <div class="baseButton">
    <component
      :is="isTag"
      ref="button"
      class="baseButton__button"
      :class="[
        {disabled : isDisabled},
        design !== '' ? 'baseButton__button--' + design : ''
      ]"
      @click="clicked"
    >
      <span
        class="baseButton__button__label"
        :class="{disabled : isDisabled && !btnLabelEnable}"
      >{{ label }}
      </span>
    </component>
  </div>
</template>

<script>
export default {
  name: 'baseButton',
  props: {
    // a タグなどに変更したい場合に使用
    tag: {
      type: String,
      default: 'span'
    },
    label: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: '/'
    },
    isDisabled:{
      type: Boolean,
      default: false
    },
    btnLabelEnable: {
      type: Boolean,
      default: false
    },
    design: {
      type: String,
      default: ''
    },
  },
  computed: {
    // タグを設定
    isTag () {
      return this.tag
    }
  },
  mounted () {
    // href 設定
    if (this.tag === 'a') {
      this.$refs.button.setAttribute('href', this.href)
    }
  },
  methods: {
    clicked(){
      if(!this.isDisabled) {
        this.$emit('clicked')
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.baseButton{
  $root: &;
  text-align: center;
  width: 100%;

  &__button{
    width: 100%;
    min-width: 270px;
    display: inline-block;
    font-weight: 700;
    font-size: 14px;
    color: $col_white;
    text-decoration: none;
    padding: 16px 32px;
    border-radius: 32px;
    cursor: pointer;
    position: relative;
    z-index: 1;
    background: $col_def_gradient;
    box-shadow: 5px 5px 15px rgba(0,0,0,.15);
    text-align: center;

    &.disabled{
      background: $col_temp_gray3;
      pointer-event: none;
    }

    &__label{
      color: $col_temp_key1;
      background: $col_def_gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      &.disabled{
        background: $col_temp_gray3;
        -webkit-background-clip: text;
      }

    &::before{
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      box-sizing: border-box;
      border-radius: 2em;
      padding: 2px;
      width: 100%;
      height: 100%;
      background: $col_white;
      background-clip: content-box;
      content: "";
    }

    }
    // design === fill
    &--fill {
      #{$root}__button__label {
        color: #fff;
        -webkit-text-fill-color: initial;
        &::before {
          display: none;
        }
      }
      &:disabled {
        #{$root}__button__label {
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/BaseButton.vue